<template>
<div class="modal-wrapper">
  <div v-if="outside" class="modal-bg" @click="$emit('closeModal')"></div>
  <div v-else class="modal-bg"></div>
  <div class="modal__inner">
    <Icon icon="close" class="modal__inner__close" @click.native="$emit('closeModal')"/>
    <slot/>
  </div>
</div>
</template>

<script>
import Icon from '../Icon/Icon';
import ClickOutside from 'vue-click-outside';

export default {
  name: "Modal",
  components: {
    Icon,
  },
  props: {
    outside: {
      type: Boolean,
      default: false,
    }
  }
};
</script>

<style src="./Modal.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Modal/Modal.vue